<template>
  <UApp :locale="ru">
    <NuxtPage />
  </UApp>
</template>

<script setup lang="ts">
import { ru } from '@nuxt/ui/runtime/locale/index.js'

defineOptions({
  name: 'UIApp',
})

useDirectoryStore()
</script>

<style lang="scss">
.page-enter-active,
.page-leave-active {
  transition: all 0.2s ease-in-out;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  transform: translateY(4px);
}
</style>
